<template>
    <div class="card-box m-b-10 p-10 relative card_color_left" :style="`border-left-color:${segment.color}`">
        <div class="table-box table_fixed table_deals">

            <div class="table-detail">

                <!-- Page -->
                <span v-pml-tooltip="$t('page')"><i class="fa fa-fw m-r-10 fa-desktop"></i>{{ item.content.page.name }}</span>

                <!-- Status Integration -->
                <span v-if="formActive" v-pml-tooltip.right="$t('active')"><i class="fa fa-circle text-custom f_size_10 m-l-5"></i></span>
                <span v-else v-pml-tooltip.right="$t('inactive')"><i class="fa fa-circle text-danger f_size_10 m-l-5"></i></span>

                <div class="clearfix m-b-5"></div>

                <!-- Campaign -->
                <span v-pml-tooltip="$t('campaign')"><i class="fa fa-fw m-r-10 fa-bullhorn"></i>{{ item.content.form.name }}</span>

            </div>

            <div class="table-detail">

                <!-- Member -->
                <span class="text-muted show m-t-10" v-if="item.content.member_id && item.content.auto_assign === 'no'" v-pml-tooltip="$t('consultant')">
                    <i class="md-headset-mic text-dark"></i> {{ item.content.member_id | pmlMemberById }}
                </span>
                <!-- Auto Assign -->
                <span class="text-muted show m-t-10" v-if="item.content.auto_assign === 'yes'" v-pml-tooltip="$t('approach')">
                    {{ $t('auto_assign') }}: {{ $t('_integrations.approaches.' + item.content.approach) }}
                </span>

                <!-- Follower -->
                <small class="text-muted" v-pml-tooltip="$t('follower')" v-if="item.content.follower_id">
                    <i class="fa fa-location-arrow text-dark m-r-5"></i> {{ item.content.follower_id | pmlMemberById }}
                </small>

            </div>


            <div class="table-detail t_center">

                <!-- Source -->
                <span class="label label-default" :style="`background-color:${source.color}`" v-pml-tooltip="$t('source')" v-if="item.content.source_id">{{ source.name }}</span>

            </div>

            <div class="table-detail t_center">

                <!-- Segment -->
                <span class="label label-default" :style="`background-color:${segment.color}`" v-pml-tooltip="$t('segment')" v-if="item.content.segment_id">{{ segment.name }}</span>

                <!-- Pipeline -->
                <span class="show m-t-10" v-if="item.content.pipeline_step_id" v-pml-tooltip="$t('pipeline')"><i class="fa fa-toggle-right text-dark m-r-5"></i> {{ item.content.pipeline_step_id | pmlPipelineByStepId }} <i class="fa fa-long-arrow-right"></i> {{ item.content.pipeline_step_id | pmlPipelineStepById }}</span>

            </div>

            <!-- Actions -->
            <div class="table-detail t_right w_100">
                <span class="btn btn-primary btn-xs" v-pml-tooltip="$t('refresh')" @click.prevent="getForms(item.content.page, checkConn)">
                    <i class="fa-fw fa fa-refresh"></i>
                </span>
                <router-link :to="{ name: 'integrations.facebook-leads.edit', params: { id: item.id } }" class="btn btn-warning btn-xs" v-pml-tooltip="$t('edit')">
                    <i class="fa-fw fa fa-pencil"></i>
                </router-link>
                <span class="btn btn-danger btn-xs" v-pml-tooltip="$t('delete')" @click.prevent="askToDelete" v-pml-block="isDeleting">
                    <i class="fa-fw fa fa-times"></i>
                </span>
            </div>

        </div>
    </div>
</template>

<script>
    import Notify from '@/utils/helpers/notify'
    import { trans } from '@/utils/helpers/translation'
    import { destroyFacebookLeads } from '@/services/integrations'
    import { askToDelete } from '@/utils/helpers/sweet-alert'
    import { findSource, findSegment } from '@/utils/helpers/find-store'
    import { mapGetters } from 'vuex'
    import { getForms } from '@/services/facebook'
    import { find } from 'lodash'

    export default {
        name: 'FacebookLeadsItem',
        props: [ 'item' ],
        data () {
            return {
                isDeleting: false,
                formActive: false
            }
        },
        computed: {
            ...mapGetters({
                'sources': 'getSources',
                'segments': 'getSegments'
            }),
            source () {
                return findSource(this.item.content.source_id) || {}
            },
            segment () {
                return findSegment(this.item.content.segment_id) || {}
            }
        },
        created () {
            this.getForms(this.item.content.page, this.checkConn)
        },
        methods: {
            askToDelete () {
                askToDelete()
                    .then((response) => (response.value) ? this.destroy() : null)
            },
            destroy () {
                this.isDeleting = true

                destroyFacebookLeads(this.item.id)
                    .then(() => {
                        this.$emit('deleted', this.item.id)
                        Notify.success(trans('_notifications.success'))
                    })
                    .catch(error => Notify.error(trans(error.response.data.slug)))
                    .then(() => { this.isDeleting = false })
            },
            getForms: (page, callback) => getForms(page, callback),
            checkConn (response) {
                if (response && !response.error) {
                    let form = find(response.data, (form) => form.id === this.item.content.form.id)

                    if (form && typeof form !== 'undefined' && form.status === 'ACTIVE')
                        this.formActive = true
                    else
                        this.formActive = false
                } else {
                    this.formActive = false
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/providers/facebook_leads/Item.vue